import { render, staticRenderFns } from "./VFilePond.vue?vue&type=template&id=b7cf28f6&scoped=true&"
import script from "./VFilePond.vue?vue&type=script&lang=js&"
export * from "./VFilePond.vue?vue&type=script&lang=js&"
import style0 from "./VFilePond.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./VFilePond.vue?vue&type=style&index=1&id=b7cf28f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cf28f6",
  null
  
)

export default component.exports